import React from "react";
import Invoice from "./Invoice";
import _ from "lodash";
import { TabController } from "../TabController";
import { InvoiceTabType } from "components/MainSearch/Types";

/**
 * @description - Tab container for invoice result view.
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 * */
export const InvoiceTab: React.FC<InvoiceTabType> = (props) => {
  const {
    tabInfo,
    isLoading,
    totalInvoiceSearchResult,
    isDataArchived,
    changeSortOrderEvent,
  } = props;
  const invoiceProps = _.omit(props, ["isLoading"]);

  return (
    <TabController
      isLoading={isLoading}
      isSortHidden={isDataArchived}
      changeSortOrderEvent={changeSortOrderEvent}
      tabInfo={tabInfo}
    >
      <Invoice {...invoiceProps} totalSearchResult={totalInvoiceSearchResult} />
    </TabController>
  );
};
